import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { t } from "@/lib/i18n";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { Clock, ArrowLeft } from "lucide-react";

/** Public "under development" landing shown when a non-admin tries to log in
 *  or register while PUBLIC_ACCESS_LOCKED is on. */
export default function ComingSoonPage() {
  const { lang } = useLang();
  return (
    <div className="min-h-screen bg-[#050505] text-white flex flex-col" data-testid="coming-soon-page">
      <header className="flex items-center justify-between px-6 md:px-10 py-5 border-b border-white/10">
        <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm" data-testid="coming-back">
          <ArrowLeft size={14} /> home
        </Link>
        <LanguageSwitcher />
      </header>

      <div className="flex-1 flex items-center justify-center p-6">
        <div className="max-w-xl text-center">
          <div className="w-14 h-14 mx-auto mb-6 border border-[color:var(--hq-cyan)] flex items-center justify-center">
            <Clock size={22} className="text-[color:var(--hq-cyan)]" />
          </div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-[color:var(--hq-cyan)] mb-3">
            EMRKT.CH
          </div>
          <h1 className="font-display font-light text-3xl md:text-4xl tracking-tight leading-tight mb-4">
            {t(lang, "coming_soon_title")}
          </h1>
          <p className="text-white/60 leading-relaxed">
            {t(lang, "coming_soon_body")}
          </p>
          <div className="mt-8 flex items-center justify-center gap-3">
            <Link to="/" className="hq-btn hq-btn-ghost">
              {t(lang, "coming_soon_home")}
            </Link>
          </div>
        </div>
      </div>

      <footer className="px-6 md:px-10 py-5 border-t border-white/10 text-center font-mono text-[10px] uppercase tracking-widest text-white/40">
        EMRKT.CH · Autonomous commerce · Sede em Suíça
      </footer>
    </div>
  );
}
